import { atom } from 'jotai';

const nicknamesFiltersAtom = atom({
  q: '',
}, (get, set, update) => {
  set(nicknamesFiltersAtom, {
    ...get(nicknamesFiltersAtom),
    ...update,
  });
});

const myNicknamesFiltersAtom = atom({
  q: '',
}, (get, set, update) => {
  set(myNicknamesFiltersAtom, {
    ...get(myNicknamesFiltersAtom),
    ...update,
  });
});

const selectedNicknameAtom = atom(null);

const nicknamesAtom = atom([]);

export {
  nicknamesFiltersAtom,
  myNicknamesFiltersAtom,
  nicknamesAtom,
  selectedNicknameAtom,
};
